import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { scribeDocumentBase } from './ScribePropTypes';
import { sendAdvertAnalytics } from 'apps/analytics';

import GraphicBannerWithoutAnalytics from './GraphicBannerWithoutAnalytics';
import GraphicPageComponent from 'apps/analytics/components/GraphicPageComponent';
import GraphicImpression from 'apps/gtm/containers/GraphicImpression';

import impressionTypes from 'apps/gtm/utils/gtmImpressionTypes';
import sendPromotionClickEvent from 'apps/gtm/utils/sendPromotionClickEvent';
import scribeDocumentTypes from './utils/scribeDocumentTypes';

export default class GraphicBanner extends PureComponent {
  static propTypes = {
    ...scribeDocumentBase,
    classNames: PropTypes.string,
    gtmPageType: PropTypes.string.isRequired,
    imageAlt: PropTypes.string,
    imageSrc: PropTypes.string,
    parentContainer: PropTypes.shape(scribeDocumentBase),
    showOnMobile: PropTypes.bool,
    url: PropTypes.string,
    // in Scribe there are also two other content types - GRAPHIC_BANNER_CSS_SUFFIX, GRAPHIC_BANNER_BACKGROUND_COLOR,
    // but these are never used, so it makes not point to migrate these to Raven
  };

  sendAnalytics = () => {
    const {
      docNo,
      docVersionNo,
      docTitle,
      parentContainer: {
        docNo: parentNo,
        docVersionNo: parentVersionNo,
        docTitle: parentTitle,
      },
      gtmPageType,
    } = this.props;
    sendAdvertAnalytics(this.props, this.props.parentContainer);
    sendPromotionClickEvent({
      id: docNo,
      id2: `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`,
      text: docTitle,
      creative: parentTitle,
      position: scribeDocumentTypes.GRAPHIC_BANNER,
      gtmPageType,
    });
  };

  render() {
    const { imageSrc } = this.props;

    if (!imageSrc) {
      return null;
    }

    const {
      docNo,
      docVersionNo,
      docTitle,
      parentContainer: {
        docNo: parentNo,
        docVersionNo: parentVersionNo,
        docTitle: parentTitle,
      },
      ...otherProps
    } = this.props;
    const id2 = `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`;

    return (
      <Fragment>
        <GraphicPageComponent
          docNo={docNo}
          docVersionNo={docVersionNo}
          parentNo={parentNo}
          parentVersionNo={parentVersionNo}
          description="GRAPHIC_BANNER"
        />
        <GraphicImpression
          id={docNo}
          id2={id2}
          name={docTitle}
          creative={parentTitle}
          position={impressionTypes.GRAPHIC_BANNER}
        />
        <GraphicBannerWithoutAnalytics
          onClick={this.sendAnalytics}
          {...otherProps}
        />
      </Fragment>
    );
  }
}

